class TCCCartDrawer extends HTMLElement {
    constructor() {
        super(),
            (this.handleOpenCart = () => this.openCart()),
            (this.handleCartItemClick = (t) => this.handleCartItemInteractions(t)),
            (this.handleUpsellClick = (t) => {
                const e = t.currentTarget;
                e.classList.add("loading"),
                    fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json", Accept: "application/json" },
                        body: JSON.stringify({ id: e.getAttribute("data-vid"), quantity: 1 }),
                    })
                        .then((t) => t.json())
                        .then(() => this.checkFreeProduct())
                        .catch((t) => {
                            console.error("Error adding to cart:", t), e.classList.remove("loading");
                        });
            }),
            (this.boundCloseCart = () => this.closeCart()),
            (this.boundCloseCartOverlay = () => this.closeCart()),
            (this.sectionId = this.getAttribute("data-section-id"));
    }
    connectedCallback() {
        if (
            ((this.cartItemsContainer = this.querySelector(".g-cart-items")),
            (this.cartCountEl = this.querySelector(".cart-count")),
            (this.cartTotalEl = this.querySelector(".cart-total")),
            (this.cartContent = this.querySelector("#g-cart-content")),
            (this.cartDrawer = this.querySelector("#g-cart-content .g-cart-drawer")),
            (this.cartOverlay = this.querySelector(".g-cart-overlay")),
            (this.closeButton = this.querySelector(".g-close")),
            (this.upsellButtons = this.querySelectorAll(".g-cart-upsell-content button")),
            (this.checkoutBtn = this.querySelector(".g-cart-checkout")),
            (this.freeProductId = parseInt(this.dataset.freeProductId)),
            (this.freeProductVariantId = parseInt(this.dataset.freeProductVariantId)),
            (this.sectionId = this.dataset.sectionId),
            (this.freegiftEnabled = "true" === this.dataset.freegiftEnabled),
            (this.freegiftThreshold = parseInt(this.dataset.freegiftThreshold) || 0),
            (this.stocklabel = this.dataset.stocklabel),
            (this.freegiftProductIds = (this.dataset.freegiftProductIds || "").split(",").map(Number).filter(Boolean)),
            (this.freegiftVariantIds = (this.dataset.freegiftVariantIds || "").split(",").map(Number).filter(Boolean)),
            (this.triggerProductIds = (this.dataset.triggerProductIds || "").split(",").map(Number).filter(Boolean)),
            (this.excludedIds = (this.dataset.excludedIds || "").split(",").map(Number).filter(Boolean)))
        ) {
            this.initPulse();
        }
        if (
            ((this.upsellLabelElement = this.querySelector("#g-upsell-label-title")),
            (this.upsellLabelText = this.getAttribute("data-upsell-label")),
            (this.upsellMin = parseInt(this.getAttribute("data-upsell-min"))),
            (this.upsellMax = parseInt(this.getAttribute("data-upsell-max"))),
            this.upsellLabelElement)
        ) {
            const t = "g-upsell-random";
            let e = localStorage.getItem(t);
            e ||
                ((e = Math.floor(Math.random() * (this.upsellMax - this.upsellMin + 1)) + this.upsellMin),
                localStorage.setItem(t, e)),
                (this.upsellLabelElement.innerHTML = this.upsellLabelText.replace("[X]", `${e}%`));
        }
        (this.productToggle = this.querySelector('.g-cart-cta .product-toggle input[type="checkbox"]')),
            this.productToggle &&
                ((this.handleProductToggle = async (t) => {
                    const e = t.target.checked,
                        r = parseInt(t.target.dataset.vid);
                    if (e)
                        await fetch("/cart/add.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json", Accept: "application/json" },
                            body: JSON.stringify({ id: r, quantity: 1, sections: `${this.sectionId},get-cart-bubble` }),
                        }),
                            this.refreshCart();
                    else {
                        const t = await fetch("/cart.js"),
                            e = (await t.json()).items.find((t) => t.variant_id === r);
                        e &&
                            (await fetch("/cart/change.js", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    id: e.key,
                                    quantity: 0,
                                    sections: `${this.sectionId},get-cart-bubble`,
                                }),
                            }),
                            this.refreshCart());
                    }
                }),
                this.productToggle.removeEventListener("change", this.handleProductToggle),
                this.productToggle.addEventListener("change", this.handleProductToggle)),
            document.querySelectorAll('input.subscribe-checkbox[name="subscribeCheckbox"]').forEach((t) => {
                const e = t.cloneNode(!0);
                t.parentNode.replaceChild(e, t),
                    e.addEventListener("change", async (t) => {
                        const e = t.target.value,
                            r = t.target.dataset.sp,
                            i = parseInt(t.target.dataset.quantity) || 1,
                            s = t.target.checked;
                        try {
                            await fetch("/cart/change.js", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ id: e, quantity: i, selling_plan: s ? r : "" }),
                            }),
                                this.refreshCart();
                        } catch (t) {
                            console.error("[Subscribe] Failed to update cart:", t);
                        }
                    });
            }),
            (this.deliveryDateEl = this.querySelector("#g-delivery-date")),
            (this.additionalDays = parseInt(this.dataset.additionalDays) || 0),
            this.additionalDays > 0 && this.updateDeliveryDate(this.additionalDays),
            (this.countTimerDate = this.getAttribute("data-count-timer-date")),
            (this.countTimerTime = this.getAttribute("data-count-timer-hours")),
            (this.countTimerDate || this.countTimerTime) && this.startCountdownTimer(),
            this.checkoutBtn &&
                this.checkoutBtn.addEventListener("click", () => {
                    window.location.href = "/checkout";
                }),
            this.startMiniTimer(),
            document.removeEventListener("gOpenCart", this.handleOpenCart),
            document.addEventListener("gOpenCart", this.handleOpenCart),
            this.closeButton &&
                (this.closeButton.removeEventListener("click", this.boundCloseCart),
                this.closeButton.addEventListener("click", this.boundCloseCart)),
            this.cartOverlay &&
                (this.cartOverlay.removeEventListener("click", this.boundCloseCartOverlay),
                this.cartOverlay.addEventListener("click", this.boundCloseCartOverlay)),
            this.cartItemsContainer &&
                (this.cartItemsContainer.removeEventListener("click", this.handleCartItemClick),
                this.cartItemsContainer.addEventListener("click", this.handleCartItemClick)),
            this.upsellButtons.forEach((t) => {
                t.removeEventListener("click", this.handleUpsellClick),
                    t.addEventListener("click", this.handleUpsellClick);
            }),
            this.initSwiper(),
            this.initSelectListeners();
    }
    disconnectedCallback() {
        document.removeEventListener("gOpenCart", this.handleOpenCart),
            this.cartItemsContainer && this.cartItemsContainer.removeEventListener("click", this.handleCartItemClick),
            clearInterval(this.countdownInterval),
            clearInterval(this.miniTimerInterval),
            clearInterval(this.pulseInterval);
    }

    initPulse() {
        this.pulseTimer = this.querySelector('#g-bottom-text');
        this.pulseMin = parseInt(this.getAttribute('data-timer-min'));
        this.pulseMax = parseInt(this.getAttribute('data-timer-max'));
        this.stocklabel = this.dataset.stocklabel;

        if (this.pulseTimer) {
            const getRandomPeople = () => Math.floor(Math.random() * (this.pulseMax - this.pulseMin + 1)) + this.pulseMin;
            const updatePulse = () => {
                this.pulseTimer.innerHTML = `<p><strong>${getRandomPeople()}</strong> ${this.stocklabel}</p>`;
            };
            updatePulse();
            clearInterval(this.pulseInterval);
            this.pulseInterval = setInterval(updatePulse, 6000);
        }
    }

    startMiniTimer() {
        const t = this.querySelector("#g-mini-timer");
        if (!t) return;
        const e = parseInt(this.dataset.miniTimerMinutes);
        if (!e) return;
        const r = `g-mini-timer-target-${e}`;
        let i;
        const s = localStorage.getItem(r);
        s
            ? (i = new Date(parseInt(s)))
            : ((i = new Date(Date.now() + 60 * e * 1e3)), localStorage.setItem(r, i.getTime()));
        const a = t.innerHTML,
            n = () => {
                const s = i - new Date();
                if (s <= 0) return (i = new Date(Date.now() + 60 * e * 1e3)), void localStorage.setItem(r, i.getTime());
                const n = Math.floor(s / 6e4),
                    c = Math.floor((s % 6e4) / 1e3);
                t.innerHTML = a.replace("[X]", `<b>${String(n).padStart(2, "0")}:${String(c).padStart(2, "0")}</b>`);
            };
        n(), clearInterval(this.miniTimerInterval), (this.miniTimerInterval = setInterval(n, 1e3));
    }
    startCountdownTimer() {
        const t = this.querySelector("#g-lt-days"),
            e = this.querySelector("#g-lt-hours"),
            r = this.querySelector("#g-lt-minutes"),
            i = this.querySelector("#g-lt-seconds");
        if (!(t && e && r && i)) return;
        const s = () => {
                if (!this.countTimerDate) {
                    localStorage.removeItem("g-timer-target-date");
                    const t = localStorage.getItem("g-timer-target-hours");
                    if (t) return new Date(parseInt(t));
                    if (!this.countTimerTime) return null;
                    const e = new Date(Date.now() + 60 * parseInt(this.countTimerTime) * 60 * 1e3);
                    return localStorage.setItem("g-timer-target-hours", e.getTime()), e;
                }
                localStorage.removeItem("g-timer-target-hours");
                const t = localStorage.getItem("g-timer-target-date");
                if (t) return new Date(parseInt(t));
                const e = new Date(this.countTimerDate);
                return localStorage.setItem("g-timer-target-date", e.getTime()), e;
            },
            a = () => {
                let a = s();
                if (!a) return;
                let n = a - new Date();
                if (n <= 0) {
                    if (
                        (localStorage.removeItem("g-timer-target-hours"),
                        localStorage.removeItem("g-timer-target-date"),
                        (a = s()),
                        !a)
                    )
                        return;
                    n = a - new Date();
                }
                (t.textContent = String(Math.floor(n / 864e5)).padStart(2, "0")),
                    (e.textContent = String(Math.floor((n % 864e5) / 36e5)).padStart(2, "00")),
                    (r.textContent = String(Math.floor((n % 36e5) / 6e4)).padStart(2, "00")),
                    (i.textContent = String(Math.floor((n % 6e4) / 1e3)).padStart(2, "00"));
            };
        a(), clearInterval(this.countdownInterval), (this.countdownInterval = setInterval(a, 1e3));
    }
    getOrdinalSuffix(t) {
        if (t > 3 && t < 21) return "th";
        switch (t % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }
    updateDeliveryDate(t) {
        if (!this.deliveryDateEl) return;
        const e = new Date();
        e.setDate(e.getDate() + t);
        const r = e.toLocaleString("default", { month: "short" }),
            i = e.getDate();
        this.deliveryDateEl.textContent = `${r} ${i}${this.getOrdinalSuffix(i)}`;
    }
    async checkFreeProduct() {
        const t = (document.documentElement.lang || "en").toLowerCase(),
            [e, r] = await Promise.all([fetch("/cart.js"), fetch(`/${t}?sections=${this.sectionId}`)]),
            [i, s] = await Promise.all([e.json(), r.json()]),
            a = new DOMParser()
                .parseFromString(s[this.sectionId], "text/html")
                .querySelector("#g-cart-content .g-cart-drawer");
        a && this.cartDrawer && ((this.cartDrawer.innerHTML = a.innerHTML), this.reInitCartElements()),
            await this.checkAutoFreeGifts(i);
        this._cguSyncHeaderCount();
    }
    async checkAutoFreeGifts(t) {
        // CGU: custom-board design gift. #cgu-gift-cfg is rendered in the drawer from the same cart state.
        const cfg = this.querySelector("#cgu-gift-cfg"),
            dPid = cfg ? Number(cfg.dataset.designPid) : 0,
            dVid = cfg ? Number(cfg.dataset.designVid) : 0,
            dWant = !!cfg && "true" === cfg.dataset.custom;
        let dChanged = !1;
        if (dPid && dVid) {
            const dLine = t.items.find((i) => i.product_id === dPid);
            try {
                dWant && !dLine
                    ? (await fetch("/cart/add.js", {
                          method: "POST",
                          headers: { "Content-Type": "application/json", Accept: "application/json" },
                          body: JSON.stringify({ items: [{ id: dVid, quantity: 1, properties: { _free_gift: !0 } }] }),
                      }),
                      (dChanged = !0))
                    : !dWant &&
                      dLine &&
                      (await fetch("/cart/update.js", {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify({ updates: { [dLine.key]: 0 } }),
                      }),
                      (dChanged = !0));
                dChanged && (t = await (await fetch("/cart.js")).json());
            } catch (err) {
                console.error("[CGU] design gift sync failed", err);
            }
        }
        // CGU: free bags credit on an upgraded bag set bought with boards.
        // Upgraded bags left without boards are removed first; the credit code is synced after the free gifts are in.
        let bagCode = null;
        try {
            const bc = await this._cguBagCredit(t);
            bc && bc.cart && ((t = bc.cart), (dChanged = !0));
            bagCode = bc && bc.code;
        } catch (err) {
            console.error("[CGU] bag credit sync failed", err);
        }
        await this._checkAutoFreeGifts(t, dPid);
        if (bagCode) {
            try {
                await bagCode(), (dChanged = !0);
            } catch (err) {
                console.error("[CGU] bag credit code failed", err);
            }
        }
        dChanged && this.refreshCart();
    }
    // An upgraded bag set (line property _replaces_free_bags) replaces the free bags. While boards are in the cart
    // it gets the free bags credit code; with no boards left, the upgraded bags are removed with them.
    // Returns { cart, code }: cart = the cart after removing bags (or null), code = a function that syncs the code (or null).
    async _cguBagCredit(t) {
        const cfg = this.querySelector("#cgu-bagcredit-cfg");
        if (!cfg || !cfg.dataset.code) return null;
        const code = cfg.dataset.code,
            up = code.toUpperCase(),
            isBag = (i) => !!(i.properties && i.properties._replaces_free_bags),
            isBoard = (i) => {
                const n = String(i.product_title || "").toLowerCase();
                return i.final_price > 0 && !isBag(i) && n.includes("cornhole boards") && !n.includes("mega bundle") && !n.includes("cornhole bags");
            },
            hasBoard = "true" === cfg.dataset.board || t.items.some(isBoard);
        let bagLines = t.items.filter(isBag),
            cart = null;
        if (!hasBoard && bagLines.length > 0) {
            const rm = {};
            bagLines.forEach((i) => (rm[i.key] = 0));
            await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ updates: rm }),
            });
            cart = await (await fetch("/cart.js")).json();
            bagLines = [];
        }
        const want = hasBoard && bagLines.length > 0,
            codes = (t.discount_codes || []).map((d) => d.code).filter(Boolean),
            has = codes.some((c) => c.toUpperCase() === up),
            next = want ? codes.concat(code) : codes.filter((c) => c.toUpperCase() !== up);
        return {
            cart,
            code:
                want !== has
                    ? () =>
                          fetch("/cart/update.js", {
                              method: "POST",
                              headers: { "Content-Type": "application/json", Accept: "application/json" },
                              body: JSON.stringify({ discount: next.join(",") }),
                          })
                    : null,
        };
    }
    async _checkAutoFreeGifts(t, dPid) {
        const e = t.items.map((t) => t.product_id).filter((i) => i !== dPid);
        // CGU: an upgraded bag set (line property _replaces_free_bags = product id) replaces that free gift
        const skip = t.items.map((i) => Number(i.properties && i.properties._replaces_free_bags)).filter(Boolean);
        // CGU: bonus gifts only come with a cornhole board set (Professional, Weatherproof or custom), never for bags,
        // accessories or mega bundles alone. #cgu-gift-cfg[data-boards] is worked out in Liquid from the product collections;
        // the title check covers a drawer that was rendered a moment before the cart changed.
        const gcfg = this.querySelector("#cgu-gift-cfg"),
            paid = t.items.filter((i) => i.final_price > 0 && !this.excludedIds.includes(i.product_id) && !this.freegiftProductIds.includes(i.product_id) && i.product_id !== dPid),
            titleBoard = paid.some((i) => {
                const n = String(i.product_title || "").toLowerCase();
                return n.includes("cornhole board") && !n.includes("mega") && !n.includes("bags");
            }),
            hasBoardSet = titleBoard || (!!gcfg && "true" === gcfg.dataset.boards && paid.length > 0);
        if (hasBoardSet && t.total_price > 0) {
            const rm = {};
            skip.length > 0 &&
                t.items.forEach((i) => {
                    skip.includes(i.product_id) && i.properties && i.properties._free_gift && (rm[i.key] = 0);
                });
            const n = this.freegiftVariantIds
                .filter((t, r) => !e.includes(this.freegiftProductIds[r]) && !skip.includes(this.freegiftProductIds[r]))
                .map((t) => ({ id: t, quantity: 1, properties: { _free_gift: !0 } }));
            Object.keys(rm).length > 0 &&
                (await fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ updates: rm }),
                }));
            n.length > 0 &&
                (await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify({ items: n }),
                }));
            (Object.keys(rm).length > 0 || n.length > 0) && this.refreshCart();
        } else {
            const e = {};
            t.items.forEach((t) => {
                this.freegiftProductIds.includes(t.product_id) && (e[t.key] = 0);
            }),
                Object.keys(e).length > 0 &&
                    (await fetch("/cart/update.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ updates: e }),
                    }),
                    this.refreshCart());
        }
    }
    reInitCartElements() {
        (this.cartItemsContainer = this.querySelector(".g-cart-items")),
            (this.checkoutBtn = this.querySelector(".g-cart-checkout")),
            (this.upsellButtons = this.querySelectorAll(".g-cart-upsell-content button")),
            (this.productToggle = this.querySelector('.g-cart-cta .product-toggle input[type="checkbox"]')),
            (this.closeButton = this.querySelector(".g-close")),
            (this.cartOverlay = this.querySelector(".g-cart-overlay")),
            this.cartItemsContainer &&
                (this.cartItemsContainer.removeEventListener("click", this.handleCartItemClick),
                this.cartItemsContainer.addEventListener("click", this.handleCartItemClick)),
            this.closeButton &&
                (this.closeButton.removeEventListener("click", this.boundCloseCart),
                this.closeButton.addEventListener("click", this.boundCloseCart)),
            this.cartOverlay &&
                (this.cartOverlay.removeEventListener("click", this.boundCloseCartOverlay),
                this.cartOverlay.addEventListener("click", this.boundCloseCartOverlay)),
            this.checkoutBtn &&
                this.checkoutBtn.addEventListener("click", () => {
                    window.location.href = "/checkout";
                }),
            this.upsellButtons.forEach((t) => {
                t.removeEventListener("click", this.handleUpsellClick),
                    t.addEventListener("click", this.handleUpsellClick);
            }),
            this.initPulse(),
            this.initSelectListeners(),
            this.initSwiper();
    }
    handleCartItemInteractions(t) {
        const e = t.target,
            r = e.closest(".g-cart-item");
        if (!r) return;
        const i = r.querySelector(".g-ci-quantity"),
            s = e.closest(".g-ci-quantity-plus"),
            a = e.closest(".g-ci-quantity-minus"),
            n = e.closest(".g-remove"),
            c = e.closest(".g-ci-sub-check");
        if (c) {
            const t = r.classList.toggle("active");
            c.setAttribute("aria-checked", t ? "true" : "false"), (r.dataset.checked = t);
            const e = c.getAttribute("data-default-sp"),
                s = c.getAttribute("data-current-sp"),
                a = c.getAttribute("data-line"),
                n = parseInt(i.innerHTML);
            t ? "" === s && updateCartSellingPlan(a, n, e) : s && updateCartSellingPlan(a, n, "");
        }
        if (s) {
            s.classList.add("loading");
            const t = parseInt(s.getAttribute("data-line")),
                e = parseInt(i.innerHTML) + 1;
            (i.innerHTML = e), this.updateCartQuantity(t, e);
        }
        if (a) {
            a.classList.add("loading");
            const t = parseInt(a.getAttribute("data-line")),
                e = parseInt(i.innerHTML) - 1;
            (i.innerHTML = e), this.updateCartQuantity(t, e);
        }
        n && (n.classList.add("loading"), this.updateCartQuantity(parseInt(n.getAttribute("data-line")), 0));
    }
    initSelectListeners() {
        this.querySelectorAll(".g-cart-item-subscription select").forEach((t) => {
            const e = t.cloneNode(!0);
            t.parentNode.replaceChild(e, t),
                e.addEventListener("change", (t) => {
                    fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id: t.target.getAttribute("data-key"),
                            quantity: t.target.getAttribute("data-qty"),
                            selling_plan: t.target.value,
                        }),
                    })
                        .then((t) => t.json())
                        .then(() => this.refreshCart())
                        .catch(console.error);
                });
        });
    }
    async initSwiper() {
        const t = this.querySelector(".g-cart-upsells-slider");
        if (!t) {
            // CGU: no upsell slider yet, so fetch Swiper once the page is idle instead of during page load
            if (!window.Swiper && !this._swiperIdle) {
                this._swiperIdle = !0;
                const go = () => this.loadSwiperAssets().catch(() => {});
                "requestIdleCallback" in window ? requestIdleCallback(go, { timeout: 4e3 }) : setTimeout(go, 3e3);
            }
            return;
        }
        await this.loadSwiperAssets();
        t &&
            (t.swiper && t.swiper.destroy(!0, !0),
            new Swiper(t, {
                grabCursor: !0,
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: { nextEl: ".g-cus-next", prevEl: ".g-cus-prev" },
            }));
    }
    async loadSwiperAssets() {
        if (window.__cguSwiperP) return window.__cguSwiperP;
        return (window.__cguSwiperP = this._loadSwiperAssets().catch((e) => { window.__cguSwiperP = null; throw e; }));
    }
    async _loadSwiperAssets() {
        const t = [];
        window.Swiper || t.push(this.loadScript("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js")),
            document.querySelector('link[href*="swiper"]') ||
                t.push(this.loadStylesheet("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css")),
            t.length && (await Promise.all(t));
    }
    loadScript(t) {
        return new Promise((e, r) => {
            const i = document.createElement("script");
            (i.src = t), (i.onload = e), (i.onerror = r), document.head.appendChild(i);
        });
    }
    loadStylesheet(t) {
        return new Promise((e, r) => {
            const i = document.createElement("link");
            (i.rel = "stylesheet"), (i.href = t), (i.onload = e), (i.onerror = r), document.head.appendChild(i);
        });
    }
    async updateCartQuantity(t, e) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ line: t, quantity: e }),
        })
            .then((t) => t.json())
            .then(() => this.checkFreeProduct())
            .catch((t) => console.error("Error updating cart:", t));
    }
    async refreshCart() {
        const t = (document.documentElement.lang || "en").toLowerCase(),
            e = await fetch(`/${t}?sections=${this.sectionId}`),
            r = await e.json(),
            i = new DOMParser()
                .parseFromString(r[this.sectionId], "text/html")
                .querySelector("#g-cart-content .g-cart-drawer");
        i && this.cartDrawer && ((this.cartDrawer.innerHTML = i.innerHTML), this.reInitCartElements());
        this._cguSyncHeaderCount();
    }
    // CGU: keep the header cart bubble (Impact <cart-count>) in step with the real cart after every drawer change
    async _cguSyncHeaderCount() {
        try {
            const c = await fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } }).then((x) => x.json());
            const on = c.item_count > 0;
            document.querySelectorAll("cart-count").forEach((el) => {
                el.itemCount = c.item_count;
                el.classList.toggle("opacity-0", !on);
                el.style.opacity = on ? "1" : "0";
            });
        } catch (err) {}
    }
    openCart() {
        (this.style.visibility = "visible"),
            document.body.style.setProperty("overflow", "hidden", "important"),
            this.cartContent && this.cartContent.classList.add("g-cart-open"),
            this.checkFreeProduct();
    }
    closeCart() {
        (this.style.visibility = "hidden"),
            document.body.style.setProperty("overflow", "auto", "important"),
            this.cartContent && this.cartContent.classList.remove("g-cart-open");
    }
}
customElements.define("tcc-cart-drawer", TCCCartDrawer),
    (function () {
        const t = document.querySelector('input.subscribe-checkbox[name="subscribeCheckbox"]');
        t &&
            t.addEventListener("change", async function () {
                try {
                    await fetch("/cart/change.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            id: this.value,
                            quantity: this.dataset.quantity,
                            selling_plan: this.checked ? this.dataset.sp : "",
                        }),
                    });
                    const t = document.querySelector("tcc-cart-drawer");
                    t && t.refreshCart();
                } catch (t) {
                    console.error("[Subscribe] Failed to update cart:", t);
                }
            });
    })(),
    document.addEventListener("click", function (t) {
        const e = t.target.closest("a");
        e && e.href.includes("/cart") && (t.preventDefault(), document.dispatchEvent(new Event("gOpenCart")));
    }),
    document.addEventListener(
        "submit",
        function (t) {
            const e = t.target;
            e.action.includes("/cart/add") &&
                (t.stopImmediatePropagation(),
                t.preventDefault(),
                document.dispatchEvent(new Event("gOpenCart")),
                fetch(e.action, { method: "POST", body: new FormData(e) })
                    .then((t) => {
                        if (!t.ok) throw new Error("HTTP error! Status: " + t.status);
                        return t.text();
                    })
                    .then(() => {
                        const t = document.querySelector("tcc-cart-drawer");
                        t && (t.refreshCart(), t.checkFreeProduct());
                    })
                    .catch((t) => console.error("Error adding item to cart:", t)));
        },
        !0
    );
/* CGU: "Complete your setup" quick view — clicking a photo or name opens a photo gallery inside the cart
   instead of going to the product page. Delegated on document so it keeps working after the cart re-renders. */
(function () {
    if (window.__cguQuickView) return;
    window.__cguQuickView = true;
    function idx(t) { var w = t.clientWidth || 1; return Math.round(t.scrollLeft / w); }
    function sync(qv) {
        var t = qv.querySelector("[data-cgu-qv-track]");
        if (!t) return;
        var n = t.children.length, i = Math.min(n - 1, Math.max(0, idx(t)));
        var c = qv.querySelector("[data-cgu-qv-i]"), p = qv.querySelector("[data-cgu-qv-prev]"), x = qv.querySelector("[data-cgu-qv-next]");
        if (c) c.textContent = i + 1;
        if (p) p.disabled = i <= 0;
        if (x) x.disabled = i >= n - 1;
    }
    function open(id) {
        var qv = document.getElementById("cgu-qv-" + id);
        if (!qv) return;
        qv.hidden = false;
        var t = qv.querySelector("[data-cgu-qv-track]");
        if (t) {
            t.style.scrollBehavior = "auto"; t.scrollLeft = 0; t.style.scrollBehavior = "";
            if (!t.dataset.cguBound) { t.dataset.cguBound = "1"; t.addEventListener("scroll", function () { sync(qv); }, { passive: true }); }
        }
        sync(qv);
        requestAnimationFrame(function () { qv.classList.add("is-open"); });
        var x = qv.querySelector(".cgu-qv__x");
        x && x.focus({ preventScroll: true });
    }
    function close(qv) {
        qv.classList.remove("is-open");
        setTimeout(function () { qv.hidden = true; }, 200);
    }
    document.addEventListener("click", function (e) {
        var o = e.target.closest("[data-cgu-qv-open]");
        if (o) { e.preventDefault(); e.stopPropagation(); open(o.getAttribute("data-cgu-qv-open")); return; }
        var qv = e.target.closest(".cgu-qv");
        if (!qv) return;
        if (e.target.closest("[data-cgu-qv-close]")) { e.preventDefault(); e.stopPropagation(); close(qv); return; }
        var t = qv.querySelector("[data-cgu-qv-track]");
        if (t && e.target.closest("[data-cgu-qv-prev]")) { e.stopPropagation(); t.scrollBy({ left: -t.clientWidth, behavior: "smooth" }); }
        else if (t && e.target.closest("[data-cgu-qv-next]")) { e.stopPropagation(); t.scrollBy({ left: t.clientWidth, behavior: "smooth" }); }
    }, true);
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            var q = document.querySelector(".cgu-qv.is-open");
            if (q) { e.stopPropagation(); close(q); }
        } else if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches("span[data-cgu-qv-open]")) {
            e.preventDefault(); open(e.target.getAttribute("data-cgu-qv-open"));
        }
    }, true);
})();